/**
 * Component <e2-store-alphabet /> is used to display an alphabet letters for store-locator component.
 * By click on the letter user will be scrolled to connected stores Group.
 *
 * @attr {array} letters - array of alphabet letters
 *
 * HTML Structure Example
 *
 * <e2-store-alphabet letters='["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]'></e2-store-alphabet>
 */

import { html } from 'lit-element';

import connect from '@elab/core/store/connect';
import uiActions from '@elab/core/store/ui/actions';
import { SimpleLitElement } from '@elab/components';
import Breakpoints from '@elab/core/utils/Breakpoints';

export class StoreAlphabet extends SimpleLitElement {
    static get properties() {
        return {
            letter: { type: String },
            scrollShiftDesktop: { type: Number, attribute: 'scroll-shift-desktop' },
            scrollShiftMobile: { type: Number, attribute: 'scroll-shift-mobile' },
        };
    }

    constructor() {
        super();
        this.scrollShiftDesktop = 0;
        this.scrollShiftMobile = 0;
    }

    scrollToLetterSection = e => {
        e.preventDefault();
        const val = e.currentTarget.getAttribute('href');
        const target = `e2-store-alphabet-letter-group ${val}`;
        const shift = Breakpoints.desktopDevice ? this.scrollShiftDesktop : this.scrollShiftMobile;
        this.dispatchEvent(
            new CustomEvent('scroll-to-letter-group', { detail: { target, shift } }),
        );

        history.pushState(null, null, val);
    };

    render() {
        return html`
            <a
                class="carousel__letter-slide-link"
                @click=${this.scrollToLetterSection}
                href="#${this.letter}"
            >
                ${this.letter}
            </a>
        `;
    }
}

const mapDispatchToEvents = dispatch => ({
    'scroll-to-letter-group': ({ detail }) => dispatch(uiActions.scrollToTarget(detail)),
});

export default () =>
    customElements.define('e2-store-alphabet', connect(null, mapDispatchToEvents)(StoreAlphabet));
